export const businessRegistrationMutations = {
  setbusinessRegistrationFormType(state, payload) {
    state.businessRegistrationFormType = payload;
  },
 
};
